import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FeedbackMessage from "../FeedbackMessage";
// import logo from "../../assets/images/buscar-logo-light.png";
import logo from "../../assets/images/tcr-logo-light.png";
import Navigation from "./components/Navigation";
import "./styles.scss";

const Template = ({ component: Component, ...props }) => {
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    setErrorMessage(null);
  }, [Component]);

  return (
    <div id="container">
      {localStorage.getItem("access_token") && <Navigation />}

      <div className="content">
        {!localStorage.getItem("access_token") && (
          <div className="logo">
            <Link to="/">
              <img alt="BusCAR logo" src={logo} />
            </Link>
          </div>
        )}
        <Component setError={setErrorMessage} {...props} />
      </div>
      {errorMessage && (
        <FeedbackMessage
          message={errorMessage}
          onDismiss={() => setErrorMessage(null)}
        />
      )}
    </div>
  );
};

export default Template;
